var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_2154)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_526_2154)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.0875 4.91824H18.3205V1.13252C17.2393 1.01984 16.153 0.964208 15.0661 0.965856C11.8354 0.965856 9.62614 2.94205 9.62614 6.5611V9.68015H5.97974V13.9182H9.62614V24.7754H13.9971V13.9182H17.6316L18.178 9.68015H13.9971V6.97776C13.9971 5.72776 14.3296 4.91824 16.0875 4.91824Z",
    fill: "#C7C7C7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_2154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.15625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_526_2154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0952,
    height: 25,
    fill: "white",
    transform: "translate(5.95239 0.15625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebook);
export default __webpack_public_path__ + "static/media/footerFacebook.70b29fa914afc4eb2f33bc253a102118.svg";
export { ForwardRef as ReactComponent };